import { createAction, props } from "@ngrx/store";
import { FormulaGroup } from "../../models/formulas/formula-group";

export const findFormulaGroupAct = createAction('findFormulaGroupEffect', props <{ id: number }>());
export const loadFormulaGroupByIdAct = createAction('loadFormulaGroupByIdEffect', props<{ formulaGroup: FormulaGroup }>());

export const resetFormulaGroupAct = createAction('resetFormulaGroupEffect');

export const updateFormulaGroupAct = createAction('updateFormulaGroupEffect', props<{ formulaGroupUpdated: FormulaGroup }>());
export const updateSuccessFormulaGroupAct = createAction('updateSuccessFormulaGroupEffect', props<{ formulaGroupUpdated: FormulaGroup }>());

export const saveFormulaGroupAct = createAction('saveFormulaGroupEffect', props<{ formulaGroupNew: FormulaGroup }>());
export const saveSuccessFormulaGroupAct = createAction('saveSuccessFormulaGroupEffect', props<{ formulaGroupNew: FormulaGroup }>());

export const setViolationsFormulaGroupAct = createAction('setViolationsFormulaGroupEffect', props<{ formulaGroupForm: FormulaGroup, violations: {} }>());
export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );
